import axios from 'axios'

import { REACT_APP_SITE_KEY, REACT_APP_API_URL } from '../shared/vars'

export default class ChunkUploader {
    constructor(){
        this.log                 = false
        this.CHUNK_LIMIT         = 80000
        this.current_file_index  = 0
        this.file_data           = {}
        this.fileType            = ''
        this.totalChunks         = 0
        this.fileName            = ''
        this.mimeType            = ''
        this.userToken           = ''
        this.readerBlob          = null
        this.progressCallback    = null
        this.tokenUpdateFunction = null
        this.uploaderIndex       = 0
    }

    deleteTempImages(imageDirs, token) {
        return new Promise((resolve, reject) => {
            let deletePromises = []
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
            imageDirs.forEach(dir => {
                deletePromises.push(axios.delete(REACT_APP_API_URL + 'temp-images?dir=' + dir, { headers: AUTH_HEADER })
                    .then(response => {
                        resolve(response)
                    })
                    .catch((err) => {
                        reject(err)
                    })
                )
            })

            return Promise.all(deletePromises)
                .then(res => {
                    return resolve(res)
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

    uploadFile(type, file, token, tokenUpdateFunction, uploaderIndex = 0, progressCallback = null){
    
        if(this.log) console.log('prepRequest')

        return new Promise((resolve, reject) => {
            if(!file){
                return reject('Unable to determine the file to upload')
            }

            // Assign vars
            this.uploaderIndex       = uploaderIndex
            this.progressCallback    = progressCallback
            this.tokenUpdateFunction = tokenUpdateFunction
            this.fileType            = type
            this.mimeType            = file.type
            this.userToken           = token
            this.fileName            = file.name

            // const fileSize = getFileSize(fullBlob)

            const reader = new FileReader()

            reader.onload = (e) => {

                if(this.log) console.log("loaded reader: ", reader)

                this.readerBlob = reader.result

                // return reject(readerBlob)

                this.file_data[this.current_file_index]           = {}
                this.file_data[this.current_file_index]['dom_id'] = this.current_file_index
                this.file_data[this.current_file_index]['blob']   = file.fileString
                this.file_data[this.current_file_index]['SIZE']   = this.readerBlob.length
                this.file_data[this.current_file_index]['name']   = this.fileName
                
                this.totalChunks = Math.ceil(this.readerBlob.length / this.CHUNK_LIMIT)
        
                this.file_data[this.current_file_index]['NUM_CHUNKS']   = this.totalChunks
                this.file_data[this.current_file_index]['CHUNK_INDEX']  = 0
                this.file_data[this.current_file_index]['TOTAL_LOADED'] = 0
                this.file_data[this.current_file_index]['start']        = 0

                if(this.log){
                    console.log("Name: "+this.fileName)
                    console.log("Full size:", file.size)
                    console.log("String length: ", this.CHUNK_LIMIT)
                    console.log("Size: "+this.file_data[this.current_file_index]['SIZE'])
                    console.log("Sending # of chunks: "+this.file_data[this.current_file_index]['NUM_CHUNKS'])
                }
                
                return this.sendChunk().then(res => {
                    return resolve(res)
                })
                .catch(err => {
                    return reject(err)
                })
            }

            // Load dataURL into reader
            reader.readAsDataURL(file)
        })
    }

    sendChunk(){

        if(this.log) console.log('sendChunk')

        return new Promise((resolve, reject) => {

            if(this.progressCallback){
                // console.log('percentage:', this.current_file_index + ' / ' + this.totalChunks)
                const percentage = (this.current_file_index / this.totalChunks) * 100
                this.progressCallback(this.uploaderIndex, parseFloat(percentage).toFixed(2))
            }

            const currentOffset = this.CHUNK_LIMIT * this.current_file_index
            const currentChunk  = this.readerBlob.substring(currentOffset, currentOffset + this.CHUNK_LIMIT)

            if(this.log) console.log('this.current_file_index:', this.current_file_index)
            if(this.log) console.log('currentOffset:', currentOffset)

            var data = new FormData()

            // Prep data for upload
            data.append('type', this.fileType)
            data.append('name', this.fileName)
            data.append('index', this.current_file_index)
            data.append('dataChunk', currentChunk)
            data.append('mimeType', this.mimeType)

            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.userToken }
            return axios.post(REACT_APP_API_URL + 'chunk-upload/', data, { headers: AUTH_HEADER })
            .then((response) => {

                // Check for errors
                if(!!response.data.error){
                    return reject({
                        obj: response,
                        error: response.data.error
                    })
                }
                if(!!response.data.message){
                    return reject({
                        obj: response,
                        error: response.data.message
                    })
                }

                // Set new user token
                this.userToken = response.data.token
                this.tokenUpdateFunction('admin', this.userToken)
                
                // Send next file
                this.current_file_index++
                if(this.current_file_index < this.totalChunks){
                    return this.sendChunk()
                    .then(res => {
                        return resolve(res)
                    })
                    .catch(err => {
                        return reject({
                            obj: err,
                            error: err
                        })
                    })
                
                // Merge all uploaded files
                }else{
                    this.progressCallback(this.uploaderIndex, parseFloat(100).toFixed(2), 'Finishing up...')

                    return this.mergeChunks().then(res => {
                        this.progressCallback(this.uploaderIndex, parseFloat(100).toFixed(2), 'Complete!')
                        return resolve(res)
                    })
                    .catch(err => {
                        return reject({
                            obj: err,
                            error: err
                        })
                    })
                }
            })
            .catch((err) => {
                if(err.response){
                    return reject({
                        obj: err.response,
                        error: err.response.data.error ? err.response.data.error : err.response.data.message
                    })
                }else{
                    return reject({
                        obj: err,
                        error: err.message
                    })
                }
            })
        })
    }

    mergeChunks(){
        
        if(this.log) console.log('mergeChunks')
        
        return new Promise((resolve, reject) => {

            // Prep data for upload
            const data = {
                name: this.fileName
            }

            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.userToken }
            return axios.post(REACT_APP_API_URL + 'chunk-upload/merge', data, { headers: AUTH_HEADER })
            .then((response) => {

                // Check for errors
                if(!!response.data.error){
                    return reject(response.data.error)
                }
                if(!!response.data.message){
                    return reject(response.data.message)
                }

                // Set new user token
                this.userToken = response.data.token
                this.tokenUpdateFunction('admin', this.userToken)

                return resolve(response.data)
            })
            .catch((err) => {
                if(err.response){
                    return reject(err.response.data.error ? err.response.data.error : err.response.data.message)
                }else{
                    return reject(err.message)
                }
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/ChunkUploader.js